import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/logo.png'
import _imports_1 from '../../assets/img/logo-white.png'
import _imports_2 from '../../assets/img/icons/sidebar-menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-300d56ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "navbar navbar-expand-lg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-brand d-lg-none" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-light",
    src: _imports_0,
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-dark",
    src: _imports_1,
    alt: "logo"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other-option d-lg-none" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "option-item" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "search-btn",
      "data-bs-toggle": "modal",
      "data-bs-target": "#searchModal"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "ri-search-line" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-toggler",
    "data-bs-toggle": "offcanvas",
    href: "#navbarOffcanvas",
    role: "button",
    "aria-controls": "navbarOffcanvas"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "burger-menu" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "top-bar" }),
      /*#__PURE__*/_createElementVNode("span", { class: "middle-bar" }),
      /*#__PURE__*/_createElementVNode("span", { class: "bottom-bar" })
    ])
  ])
], -1))
const _hoisted_5 = { class: "collapse navbar-collapse" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "sidebar-toggler",
  "data-bs-toggle": "offcanvas",
  href: "#navbarOffcanvas",
  role: "button",
  "aria-controls": "navbarOffcanvas"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Image"
  })
], -1))
const _hoisted_7 = { class: "navbar-nav" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-brand mx-auto" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-light",
    src: _imports_0,
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-dark",
    src: _imports_1,
    alt: "logo"
  })
], -1))
const _hoisted_10 = { class: "others-option d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"option-item\" data-v-300d56ac><form action=\"#\" class=\"search-form\" data-v-300d56ac><input type=\"text\" placeholder=\"Search\" data-v-300d56ac><button type=\"submit\" data-v-300d56ac><i class=\"ri-search-line\" data-v-300d56ac></i></button></form></div>", 1)
const _hoisted_12 = { class: "option-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['navbar-area', { sticky: _ctx.isSticky }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Home")
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-franchise",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToFranchiseForm && _ctx.scrollToFranchiseForm(...args)))
              }, " Apply Franchise ")
            ])
          ])
        ])
      ])
    ])
  ], 2))
}